module.exports = __webpack_public_path__ + "static/media/plan_roots.4718df44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/plan_roots.svg
// module id = 869
// module chunks = 0